import { Link } from '@material-ui/core';
import React from 'react';

import { PlexButton, PlexButtonProps } from './PlexButton';

interface Props extends Omit<PlexButtonProps, 'onClick'> {
  href: string;
}

export const PlexButtonHref = React.memo((props: Props) => {
  const { href, ...plexButtonProps } = props;
  const content = <PlexButton {...plexButtonProps} onClick={undefined} />;
  return props.disabled ? (
    content
  ) : (
    <Link href={href} tabIndex={-1} underline={'none'}>
      {content}
    </Link>
  );
});
